<template>
    <DCard
        padding
    >
        <Form
            :billing-cycles="billingCycles"
            :contract-term-units="contractTermUnits"
            :discount-types="discountTypes"
            :product-price="productPrice"
            :product-id="productId"
            :product-plan="productPlan"
            :errors="errors"
            :currency="currency"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductPrices/Form'

export default {
    name: 'ProductPriceUpdate',
    components: {
        Form
    },
    props: {
        productId: {
            type: Number,
            default: 0
        },
        productPlan: {
            type: Object,
            default () {
                return {}
            }
        },
        productPrice: {
            type: Object,
            default () {
                return {}
            }
        },
        billingCycles: {
            type: Array,
            default () {
                return []
            }
        },
        contractTermUnits: {
            type: Array,
            default () {
                return []
            }
        },
        discountTypes: {
            type: Array,
            default () {
                return []
            }
        },
        currency: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('products.products.plans.prices.update', {
                product: this.productId,
                plan: this.productPlan.id,
                productPrice: this.productPrice.id
            }), {
                preserveScroll: true
            })
        }
    }
}
</script>
